import {CriaFormaPagamentoComponent} from "@components/formaPagamento/CriaFormaPagamentoComponent.tsx";
import {Grid, Paper} from "@mui/material";
import {DefaultContainer} from "@shared/DefaultContainer.tsx"
import {Outlet} from "react-router";
import {PermissionableButton} from "@shared/specialComponents/PermissionableButton.tsx";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {FormasPagamentoPage} from "@components/formaPagamento/pages/FormasPagamentoPage.tsx";
import usePagination from "@components/shared/hooks/usePagination.tsx";

export function FormaPagamentoIndexPage() {
    const {addPopUp} = useAlert()
    // const [pagination, setPagination] = usePagination({}, {page: 1, pageSize: 2})
    const [pagination, setPagination] = usePagination()

    return (
        <DefaultContainer titulo={'Formas de Pagamento'}
                          size={'medium'}
                          UpperComponent={<Grid size={12} container justifyContent={'space-between'}>
                              <Grid/>
                              <Grid size={6}>
                                  <PermissionableButton onClick={() => {
                                      addPopUp({
                                          title: 'Criar nova forma de pagamento',
                                          content: <CriaFormaPagamentoComponent/>
                                      })
                                  }}
                                                        permission={['CriarFormaPagamento']}>Criar Nova forma de
                                      pagamento
                                  </PermissionableButton>
                              </Grid>
                          </Grid>}
                          component={Paper}>
            <Outlet/>
            <FormasPagamentoPage pageProps={{pagination, setPagination}}/>
        </DefaultContainer>
    )
}